import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const RCSelect = listeners["select"] || function () { };
  const RCSelectAll = listeners["select-all"] || function () { };

  const UnitPosition = ({ props: { vo } }) => {
    const unitPosition = vo.row.unitPosition ? vo.row.unitPosition : "--";
    return <span>{unitPosition}</span>;
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "姓名",
      prop: "userName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "工作单位",
      prop: "deptName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "150",
      showOverflowTooltip: true,
      render: vo => <UnitPosition vo={vo} />
    },
    {
      label: "职务",
      prop: "positionName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "职级",
      prop: "positionLevelName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "性别",
      prop: "sexName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "出生年月",
      prop: "birthday",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "政治面貌",
      prop: "politicsName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "学历",
      prop: "educationName",
      minWidth: "150",
      showOverflowTooltip: true
    },
  ];
  return (
    <List
      {...args}
      onSelect={RCSelect}
      onSelectAll={RCSelectAll}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
